module.exports = __webpack_public_path__ + "img/c669b55.png";